/* 🤖 this file was generated by svg-to-ts */
export const iconFei: {
  name: 'fei';
  data: string;
} = {
  name: 'fei',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#feiusd__clip0_292_219)"><path fill="#22996E" d="M16 32c8.84 0 16-7.16 16-16S24.84 0 16 0 0 7.16 0 16s7.16 16 16 16"/><path fill="#fff" d="M16 23.13H7.24c-1.19 0-1.9-1.31-1.26-2.31l4.98-7.77c.37-.57 1-.92 1.68-.92h6.71c.68 0 1.32.35 1.68.92l4.98 7.77c.64 1-.08 2.31-1.26 2.31h-8.76zm.9-17.88 2.09 3.2a1 1 0 0 1-.84 1.55h-4.26c-.8 0-1.28-.9-.83-1.56l2.17-3.2a1 1 0 0 1 1.66.01z"/></g><defs><clipPath id="feiusd__clip0_292_219"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
